import {
  LineChart,
  formatPercentage,
  CurrencyValue,
  formatCurrency
} from '@blockanalitica/ui';
import type { SimpleChartData } from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';
import { ChartConfig } from '@blockanalitica/ui/package/types/src/components/charts/Chart';
import { useMemo } from 'react';

export default function AtRiskChartPerDropCumulative({
  data
}: {
  data: SimpleChartData[];
}) {
  const defaultConfig: ChartConfig = useMemo(() => {
    return {
      options: {
        scales: {
          x: {
            type: 'category'
          }
        }
      }
    };
  }, []);

  const yScaleValueFormatter = (value: string | number) => {
    return formatCurrency(Number(value), { maximumFractionDigits: 5 });
  };
  const valueFormatter = (value: string | number) => {
    return (
      <CurrencyValue
        value={value}
        variant="dynamic"
        options={{ currency: 'USD' }}
      />
    );
  };

  const xScaleValueFormatter = (value: string | number) => {
    return `-${formatPercentage(Number(value) / 100)}`;
  };

  const subValueFormatter = (value: string | number) => {
    return `Price drop: -${formatPercentage(Number(value))}`;
  };

  const datasets = [
    {
      xField: 'price_change',
      yField: 'collateral_liquidated_cumulative',
      label: 'At Risk'
    }
  ];

  return (
    <LineChart
      data={data}
      datasets={datasets}
      valueFormatter={valueFormatter}
      yScaleValueFormatter={yScaleValueFormatter}
      xScaleValueFormatter={xScaleValueFormatter}
      subValueFormatter={subValueFormatter}
      config={defaultConfig}
    />
  );
}
